import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Map from './components/map.component'
import Selector from './components/selector.component'

import './App.css';

// const operators = ['Altice', 'Claro', 'Viva']

const initialMapData = {
  results: [
    {
      operator_name: '',
      coverage_level: [{ h3_hexagon: '', level: 4 }],
      rsrp_level: [{ h3_hexagon: '', level: 4 }],
      rsrq_level: [{ h3_hexagon: '', level: 4 }],
      cinr_level: [{ h3_hexagon: '', level: 4 }],
    }
  ],
  legends: {
    coverage_level: [
      { value: 1, color: [255, 128, 0], description: 'Nivel 1 - RSRP<-100dBm' },
      { value: 2, color: [255, 255, 0], description: 'Nivel 2 - RSRP≥-100dBm, CINR <10dB' },
      { value: 3, color: [0, 255, 0], description: 'Nivel 3 - RSRP≥-100dBm, CINR ≥10dB' },
    ]
  }
}

const initialViewState = {
  latitude: 0,
  longitude: 0,
  zoom: 0
}

// Para determinar si es anónimo o no
const ANONYMOUS = false;

const url = './data/bench.json';

const METRICS = [
  { name: 'coverage_level', label: 'Nivel de Cobertura' },
  { name: 'rsrp_level', label: 'RSRP (dBm)' },
  { name: 'cinr_level', label: 'CINR (dB)' },
  { name: 'rsrq_level', label: 'RSRQ (dB)' },
]

function App() {

  const [mapData, setMapData] = useState(initialMapData)

  const [viewState, setViewState] = useState(initialViewState)

  const [currentMetric, setCurrentMetric] = useState('coverage_level')

  const handleCurrentMetricChange = (e) => {
    setCurrentMetric(e.target.value)
  }

  useEffect(() => {
    async function fetchData() {
      const result = await axios(url);
      setMapData(result.data);
      setViewState(result.data.initViewState)
    }
    fetchData();
  }, []);

  const handleViewStateChange = (newViewState) => {
    setViewState({ ...newViewState.viewState })
  }

  const operators = mapData.operators ? mapData.operators : [];

  let i = 1
  let operators_an = {}
  operators.forEach(operator => {
    operators_an[operator] = `Operador #${i.toString()}`
    i++;
  })

  return (
    <div className="map-container">
      <Selector name='seleccion-indicador' title='Seleccione el indicador' value={currentMetric} options={METRICS} onChange={handleCurrentMetricChange} />
      {operators.map(operator => {
        const operatorData = mapData.results.filter(item => item.operator_name === operator);
        const operatorName = ANONYMOUS ? operators_an[operator] : operator
        return (
          operatorData &&
          <div className='map' key={operatorName}>
            <div className='map-title'>{operatorName}</div>
            <Map
              legends={mapData.legends}
              operatorName={operatorName}
              operatorData={operatorData}
              currentMetric={currentMetric}
              viewState={viewState}
              handleViewStateChange={handleViewStateChange}
              earfcnToBand={mapData.earfcn_bands}
            />
          </div>
        )
      })}
    </div>

  );
}

export default App;
